export function formatCardinality(
  c: number,
  singular: string,
  plural?: string,
) {
  if (c === 1) {
    return `${c} ${singular}`;
  }
  return `${c} ${plural || singular + "s"}`;
}
